import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environment/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomService {

  constructor(
    private http: HttpClient
  ) { }

  async getValue() {
    const body = {
    }

    return await lastValueFrom(this.http.post(`${environment.apiUrl}/${localStorage.getItem('selectedChat')}/custom/get_values`, body));
  }

  async updateCustomization(config) {
    return await lastValueFrom(this.http.post(`${environment.apiUrl}/${localStorage.getItem('selectedChat')}/custom/update_values`, config));
  }
}
